var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.tooltipClass,attrs:{"id":_vm.tooltipId}},[_c('b-tooltip',{attrs:{"target":_vm.tooltipId,"placement":_vm.placement,"triggers":_vm.triggers}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }